<template>
  <div id="locale-selector" class="dropdown">
    <a class="locale selected dropdown-toggle text-primary" aria-expanded="false" aria-haspopup="true"
       data-toggle="dropdown" href="#">
      <img :alt="currentLocaleName" :src="'/images/flags/' + currentLocale + '.svg'"/>
      <span>{{ currentLocaleName }}</span>
    </a>

    <div class="dropdown-menu">
      <template v-for="locale in locales">
        <a v-if="locale.code !== currentLocale" :href="switchLocale(locale.code)" class="dropdown-item locale">
          <img :alt="locale.name" :src="'/images/flags/' + locale.code + '.svg'"/>
          <span>{{ locale.name }}</span>
        </a>
      </template>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {usePage} from '@inertiajs/vue3';

const props = defineProps({
  routeTo: Object,
});

const locales = computed(() => usePage().props.locales);
const currentLocale = computed(() => usePage().props.currentLocale);
const currentLocaleName = computed(() => locales.value.find(locale => locale.code === currentLocale.value)?.name);

const switchLocale = (locale) => {
  const query = {...props.routeTo.query}
  delete query['lang']

  if (locale !== 'en') {
    query['lang'] = locale
  }

  return route(props.routeTo.name, {
    ...props.routeTo.params,
    _query: query
  })
}
</script>

<style scoped lang="scss">
#locale-selector {
  .locale {
    display: block;

    img {
      width: 35px;
      margin-right: 0.5rem;
    }
  }

  .dropdown-menu {
    margin-left: -0.5rem;

    .locale {
      padding: 0.5rem;
    }
  }
}
</style>
